import styled from 'styled-components';

import InfinitySvg from 'assets/infinity.svg';

export const InfinityIcon = styled(InfinitySvg)``;

